import { AxiosInstance } from 'axios';

const dosificadoraExportServices = (instance: AxiosInstance) => {
  // Descarga el Excel de la marca indicada, para el sitio del usuario logueado
  // (usuTipo ya resuelto por VARIANT/variantesId, no se elige en esta pantalla).
  // responseType blob por ser binario.
  const downloadExcel = (marca: string, usuTipo: number) =>
    instance.get('/export-dosificadoras', {
      params: { marca, usuTipo },
      responseType: 'blob',
    });

  return { downloadExcel };
};

export default dosificadoraExportServices;
